export const normalizePropValue = (
  value: number | null | undefined,
  preserveZero = false,
) => {
  if (value === null || value === undefined) return ""
  if (value === 0) return preserveZero ? "0" : ""
  return String(value)
}

export const isPartialInput = (raw: string) =>
  raw === "" || raw === "-" || raw === "-." || raw.endsWith(".")

export const parseRawValue = (raw: string): number | null => {
  if (isPartialInput(raw)) return null

  const normalized = raw.replace(/,/g, "")
  const parsed = Number(normalized)

  return Number.isNaN(parsed) ? null : parsed
}

export const shouldPreserveUserInput = (raw: string, value: number | null | undefined) => {
  const parsed = parseRawValue(raw)

  return isPartialInput(raw) || (raw.includes(".") && parsed === value)
}

/**
 * Text the field shows after the balance link is clicked. Zero is kept as "0" so a
 * click on an empty wallet still gives visible feedback.
 */
export const balanceClickDisplayValue = (balance: number) => normalizePropValue(balance, true)
